module.exports = __webpack_public_path__ + "img/expand-outline.5a5f1b43.svg";